import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import NodeProjectSchool from './School';
import NodeProjectDayProgram from './DayProgram';
import { NodeProject } from '../../../types/uncinc_profile/nodes';

import { PROJECT_TYPE_SCHOOL, PROJECT_TYPE_DAY_PROGRAM } from '../../../config/constants';

type ProjectViewMode = 'teaser';

interface NodeProjectProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeProject>;
  viewMode: ProjectViewMode;
}

const NodeProjectWrapper: React.FC<NodeProjectProps> = ({ entity, viewMode, ...props }) => {
  const node = entity.toJS();
  const type = node.field_project_type?.[0]?.entity?.name[0].value || PROJECT_TYPE_SCHOOL;

  switch (type) {
    case PROJECT_TYPE_SCHOOL: {
      return <NodeProjectSchool entity={entity} {...props} />;
    }
    case PROJECT_TYPE_DAY_PROGRAM: {
      return <NodeProjectDayProgram entity={entity} {...props} />;
    }
    default:
      return null;
  }
};

export default NodeProjectWrapper;
